document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.container-media'); 

  sections.forEach((section) => {
      const video = section.querySelector('video');
      const playButton = section.querySelector('#play-button');
      const pauseButton = section.querySelector('#pause-button');
      const containerImg = section.querySelector('.container-img');
      let firstPlay = true;


      if (video && playButton && pauseButton) {
          function toggleButtons() {
              if (video.paused) {
                  playButton.style.display = 'flex';
                  pauseButton.style.display = 'none';
              } else {
                  playButton.style.display = 'none';
                  pauseButton.style.display = 'flex';
              }
          }

          playButton.addEventListener('click', function (event) {
              event.preventDefault();
              video.play();
              toggleButtons();

              if (firstPlay && containerImg) {
                  containerImg.style.display = 'none';
                  firstPlay = false;
              }
          });

          pauseButton.addEventListener('click', function (event) {
              event.preventDefault();
              video.pause();
              toggleButtons();
          });

          video.addEventListener('click', function () {
              if (video.paused) {
                  video.play();
              } else {
                  video.pause();
              }
              toggleButtons();
          });

          video.addEventListener('play', toggleButtons);
          video.addEventListener('pause', toggleButtons);

          toggleButtons();
      }
  });
});
